import { PlatformRequestOrganization } from '@markant-platform/registration/model';
import { Industry, OrganizationType, QualificationLevel } from 'data-model';

export const MOCK_PLATFORM_REQUEST_ORGANIZATION: PlatformRequestOrganization = {
  organizationId: '66ed85e847cb08b37e764b8e',
  name: 'Brisa Inc.',
  currentQualificationLevel: QualificationLevel.LEVEL_1,
  targetQualificationLevel: QualificationLevel.LEVEL_3,
  gln: '12345',
  address: {
    street: 'That street',
    streetNumber: '123',
    zipCode: '12345',
    city: 'Berlin',
    countryCode: 'DE',
  },
  taxNumber: '132132',
  phone: '+3519292929292',
  organizationType: OrganizationType.DEALER,
  industry: Industry.DEALER,
  ezrCustomer: false,
};
